export class UserV2 {
    id;
    company = null;
    email;
    firstName;
    lastName;
    username;
    constructor(modelData = {}) {
        Object.assign(this, modelData);
    }
    get isAnonymous() {
        return !this.id;
    }
    get fullName() {
        if (this.firstName && this.lastName) {
            return `${this.firstName} ${this.lastName}`;
        }
        if (this.firstName) {
            return this.firstName;
        }
        if (this.lastName) {
            return this.lastName;
        }
        return '';
    }
}
